// extracted by mini-css-extract-plugin
module.exports = {"root":"LeftDrawer_root__BVLlV","list":"LeftDrawer_list__1fve5"};